// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"~modules/ui/variables.css\"","roboto-font":"\"Roboto\", \"Helvetica\", \"Arial\", sans-serif","app":"AppContainer_app__2Ws3o"};